//お試し参加のご案内のセクションを２つ作成し、上側を経営戦略セミナー告知等とし、下側が通常の年間ベースの告知としたい場合に、2番目のセクションは今日の日付と一番近い告知がでて動作できる仕様。
//複数のセクションを作ったとしても、一番上がこれまで通りの年間告知の場合は yamamoto_trial_participation.jsで良い

document.addEventListener("DOMContentLoaded", () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // 1. ページ内のすべての .trial_participation を取得
  const wrappers = document.querySelectorAll('.trial_participation');
  
  // 2. 2個目の要素（インデックスは 1）を指定。存在しない場合は処理を終了
  const wrapper = wrappers[1];
  if (!wrapper) return;

  const container = wrapper.querySelector('.cnt_inner');
  if (!container) return;

  const iterator = document.createNodeIterator(container, NodeFilter.SHOW_COMMENT, null, false);
  const sections = [];
  let node;

  // 1. 全てのセクション情報をリスト化
  while (node = iterator.nextNode()) {
    const text = node.nodeValue.trim();
    const match = text.match(/^(\d{4}-\d{1,2}-\d{1,2})~start$/);
    
    if (match) {
      const dateStr = match[1];
      const startDate = new Date(dateStr.replace(/-/g, '/'));
      
      let startEl = node.parentElement;
      if (startEl && startEl.previousElementSibling && startEl.previousElementSibling.classList.contains('date')) {
        startEl = startEl.previousElementSibling;
      }

      const elements = [startEl];
      let next = startEl.nextElementSibling;
      while (next) {
        elements.push(next);
        const endRegex = new RegExp(`${dateStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}~end`);
        if (endRegex.test(next.innerHTML)) break;
        if (next.innerHTML.includes('~start')) { elements.pop(); break; }
        next = next.nextElementSibling;
      }

      sections.push({
        date: startDate,
        elements: elements
      });
    }
  }

  sections.sort((a, b) => a.date - b.date);

  // 2. 表示・非表示の判定
  let foundNext = false;

  sections.forEach(section => {
    if (today > section.date) {
      section.elements.forEach(el => el.remove());
    } else {
      if (!foundNext) {
        foundNext = true; 
      } else {
        section.elements.forEach(el => el.remove());
      }
    }
  });

  // --- 未来の日付がない場合に要素を新規作成して追加 ---
  if (!foundNext) {
    // 既存の .date がないか確認（二重表示防止）
    if (!container.querySelector('.date')) {
      const newDateP = document.createElement('p');
      newDateP.className = 'date';
      newDateP.textContent = "次回日程調整中";
      
      // .cnt_inner の一番最初に追加する
      container.prepend(newDateP);
    }
  }
});